module.exports = __webpack_public_path__ + "static/img/11areaB_01.01f131f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/11areaB_01.png
// module id = 1090
// module chunks = 1